import { NgModule } from '@angular/core';
import { BrowserModule, Title  } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule } from '@nebular/theme';
import { AppComponent } from './app.component';
import { GraphQlModule } from '@core/modules/graph-ql/graph-ql.module';
import { NebularModule } from '@core/modules/nebular/nebular.module';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';

import { httpInterceptorProviders } from '@core/interceptoers';
import { NgxChartsModule }from '@swimlane/ngx-charts';
import {DragDropModule} from '@angular/cdk/drag-drop'


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    NbThemeModule.forRoot(
      {
        name: 'corporate'
      }
    ),
    NebularModule,
    CoreModule,
    GraphQlModule,
    NgxChartsModule
  ],
  exports: [
    NebularModule
  ],
  providers: [
    httpInterceptorProviders,
    Title,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
